export default __webpack_public_path__ + "static/media/pp-img.55967bff.png";